import { Row, Alert } from 'antd';
import { FC } from 'react';
import { useAuth } from 'react-oidc-context';

interface MaintenanceKickoutMessageProps {
  timer: string;
}

export const MaintenanceKickoutMessage: FC<MaintenanceKickoutMessageProps> = (props) => {
  const auth = useAuth();
  
  return (
    <Row
      justify={'center'}
      style={{
        width: '100%',
        display: "flex",
        justifyContent: auth.isAuthenticated ? "flex-end" : "center",
        height: '40px',
        top: '60px',
        left: '87px',
        position: 'fixed',
        zIndex: 1000,
      }}
    >
      <Alert
        style={{ width: '100%', textAlign: 'center', backgroundColor: 'rgba(255, 204, 51)' }}
        message={`Maintenance will begin in ${props.timer}. Please save your work and log out.`}
        type="warning"
        showIcon
      />
    </Row>
  );
};
